// extracted by mini-css-extract-plugin
export default {"base":"Navigation_base__iZsUc","items":"Navigation_items__XIVu4","containerPadding":"Navigation_containerPadding__0hwP4"};